import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@material-ui/core';
import { NumberCell, DateTimeCell, DateCell } from '../../../../utils/Cells';
import React from 'react';

export function LinkedTable({ linkedTransactions1, linkedTransactions2, groupedPayables, type, amount }) {

    React.useEffect(() => {
        console.log(groupedPayables);
    }, [groupedPayables]);

    const getTransactionSumAmount = () => {
        let sum = 0;
        linkedTransactions1.map((row) => (sum = sum + row.amount));
        linkedTransactions2.map((row) => (sum = sum + row.amount));
        return sum * -1;
    }

    const getPayableSumAmount = () => {
        let sum = 0;
        groupedPayables.map((row) => (sum = sum + row.amount));
        return sum;
    }

    return (
        <>
            {(linkedTransactions1.length + linkedTransactions2.length + groupedPayables.length !== 0) ?
                <TableContainer component={Paper}>
                    <Table size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow key="header" className='borderBottom'>
                                <TableCell></TableCell>
                                <TableCell>{type} sorszám</TableCell>
                                <TableCell>Dátum</TableCell>
                                <TableCell>Megnevezés</TableCell>
                                <TableCell>Megjegyzés</TableCell>
                                <TableCell align="right">Összeg</TableCell>
                                <TableCell align="right">Összesen</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow key="payable" className='borderBottom'>
                                <TableCell>{type}</TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell align="right"><NumberCell value={amount} /></TableCell>
                            </TableRow>
                            {linkedTransactions1.map((row) => (
                                <TableRow key={row.privateId}>
                                    <TableCell> Linkelt tranzakció </TableCell>
                                    <TableCell> {row.payablePublicId}</TableCell>
                                    <TableCell> <DateTimeCell value={row.transaction.transactionDateTime} /></TableCell>
                                    <TableCell> {row.transaction.contraName}</TableCell>
                                    <TableCell>{row.transaction.comment}</TableCell>
                                    <TableCell align="right"><NumberCell value={row.amount} /></TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            ))}
                            {linkedTransactions2.map((row) => (
                                <TableRow key={row.privateId}>
                                    <TableCell> Linkelt tranzakció </TableCell>
                                    <TableCell> {row.payablePublicId}</TableCell>
                                    <TableCell> <DateTimeCell value={row.transaction.transactionDateTime} /></TableCell>
                                    <TableCell> {row.transaction.contraName}</TableCell>
                                    <TableCell>{row.transaction.comment}</TableCell>
                                    <TableCell align="right"><NumberCell value={row.amount} /></TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            ))}
                            {linkedTransactions1.size + linkedTransactions2.size > 0 ?
                                <TableRow key="total" className='borderBottom'>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell align="right"><NumberCell value={getTransactionSumAmount()} /></TableCell>
                                </TableRow> : <></>}
                            {groupedPayables.map((row, index) => {
                                console.log(row);
                                return (
                                    <TableRow key={row.privateId}>
                                        <TableCell> Linkelt {type} </TableCell>
                                        <TableCell>{row.publicId}</TableCell>
                                        <TableCell> <DateCell value={row.billDate} /></TableCell>
                                        <TableCell>{row.partnerName}</TableCell>
                                        <TableCell>{row.comment}</TableCell>
                                        <TableCell align="right"><NumberCell value={row.amount} /></TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                )
                            })}
                            {groupedPayables.size > 0 ?
                                <TableRow key="total" className='borderBottom'>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell align="right"><NumberCell value={getPayableSumAmount()} /></TableCell>
                                </TableRow> : <></>}
                            <TableRow key="total">
                                <TableCell>Összesen</TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell align="right"><NumberCell value={amount + getPayableSumAmount() + getTransactionSumAmount()} /></TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                : <div className='details'>Nincs</div>}
        </>
    )
}